module.exports = __webpack_public_path__ + "static/media/simplemanualresults.c6dca9d1.png";